import { each } from "lodash";

export const PXModal = (function () {
	'use strict';

	function init() {
		const focusTrap = window.focusTrap

		window.onhashchange = (ev) => {
			let modalID        = window.location.hash.replace('#', '')
			    window.modalID = modalID

			if (window.location.hash.indexOf('#polywater-modal-') === -1 || !document.getElementById(modalID)) return;

			MicroModal.show(modalID);

			// preset for focus trap & activation
			window.focusTrapItem = focusTrap.createFocusTrap(`#${modalID}`)
			window.focusTrapItem.activate()
		};
	}

	return {
		init: init,
	};
})();
